import { Component, EventEmitter, OnInit, Output, ViewChild } from '@angular/core';
import { NgbModalRef, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { NgxSpinnerService } from 'ngx-spinner';
import { HearingsApiService } from 'src/app/core/services/api/hearings-api.service';
import { cities } from '../../models/cities';
import { countries } from '../../models/countries';
import { SessionNote } from '../../models/hearings/sessionNote';

@Component({
  selector: 'app-session-note-create-edit',
  templateUrl: './session-note-create-edit.component.html',
  styleUrls: ['./session-note-create-edit.component.scss']
})
export class SessionNoteCreateEditComponent implements OnInit {

  public sessionNote: SessionNote;
  public cities = cities;
  public countries = countries;

  @ViewChild('sessionNoteModal') sessionNoteModal;
  @Output() submit: EventEmitter<SessionNote> = new EventEmitter<SessionNote>();
  @Output() closeModal: EventEmitter<any> = new EventEmitter<any>();

  modalRef: NgbModalRef;

  constructor(
    private modalService: NgbModal,
    private api: HearingsApiService,
    private spinner: NgxSpinnerService
  ) { }

  ngOnInit(): void {
  }

  // handle the popup
  open(sessionNote: SessionNote) {
    this.sessionNote = Object.assign(new SessionNote(), sessionNote);
    this.modalRef = this.modalService.open(this.sessionNoteModal, {
      backdrop: 'static',
      keyboard: false,
      size: 'lg',
      centered: true
    });
  }

  close() {
    this.closeModal.emit();
    this.modalRef.close();
  }

  onSubmit() {
    if (this.sessionNote.id) {
      this.spinner.show();
      this.api.updateSessionNote(this.sessionNote).subscribe(
        c => {
          this.spinner.hide();
          this.submit.emit(c);
          this.closeModal.emit();
        }
      )
    } else {
      this.spinner.show();
      this.api.createSessionNote(this.sessionNote).subscribe(
        c => {
          this.spinner.hide();
          this.submit.emit(c);
          this.closeModal.emit();
        }
      )
    }
  }

}


